import { createApp } from 'vue';
import type { App, Component } from 'vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import StoreHelper from '@/modules/core/app/helpers/StoreHelper';
import { StaticOptionPlugin } from '@/modules/core/app/plugins/StaticOptionPlugin';
import { LocalOptionPlugin } from '@/modules/core/app/plugins/LocalOptionPlugin';
import { GlobalInjectionPlugin } from '@/modules/core/app/plugins/GlobalInjectionPlugin';
import { EventBusPlugin } from '@/modules/core/app/plugins/EventBusOptionPlugin';
import Lang from '@/modules/core/app/services/Lang';

class ComponentService {
  renderComponentToHtml(component: Component, props: Record<string, unknown>): string {
    const container: HTMLDivElement = document.createElement('div');
    const app: App = createApp(component, props);

    this.configureApp(app);
    app.mount(container);

    const html: string = container.innerHTML;
    app.unmount();

    return html;
  }

  private configureApp(app: App): void {
    app
      .use(StoreHelper.init())
      .use(StaticOptionPlugin)
      .use(LocalOptionPlugin)
      .use(GlobalInjectionPlugin)
      .use(EventBusPlugin)
      .use(Lang.i18n)
      .use(VueDOMPurifyHTML, { default: { ADD_ATTR: ['target', 'rel'] } });
  }
}

export default new ComponentService();
